/* app/js/src/components/external-mam/external-mam-gateway-playground/search-grid-components/external-mam-search-results-actions-cell/external-mam-search-results-actions-cell.component.scss */
svg {
  cursor: pointer;
}
/*# sourceMappingURL=external-mam-search-results-actions-cell.component.css.map */
